export default __webpack_public_path__ + "static/media/debug-mode-active-icon.c9f3a806.svg";